<form [formGroup]="form" novalidate>
    <div class='index filters'>
        <div class='row title'>
            Filter Results
        </div>

        <div class='row form-group' *ngIf="!isLoading">

            <div class='col-xs-12'>
                <label>Search</label>
                <input id="search" formControlName="search" placeholder='Search' class="form-control">
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Region</label>
                <ng-select id="region" formControlName="region" [items]="regions" bindValue="id" bindLabel="displayName" placeholder="Select Region"></ng-select>
            </div>
            
            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Structure</label>
                <ng-select id="structure" formControlName="structure" [items]="structures" bindValue="id" bindLabel="name" placeholder="Select Structure"></ng-select>
            </div>
            
            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Credit</label>
                <ng-select id="credit" formControlName="credit" [items]="credits" bindValue="id" bindLabel="name" placeholder="Select Credit"></ng-select>
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Status</label>
                <ng-select id="status" formControlName="status" [items]="statuses" bindValue="id" bindLabel="name" placeholder="Select Status"></ng-select>
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Budget Discipline</label>
                <ng-select id="budgetDiscipline" formControlName="budgetDiscipline" [items]="budgetDisciplines" bindValue="id" bindLabel="name" placeholder="Select Budget Discipline"></ng-select>
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Image Status</label>
                <ng-select id="image" formControlName="image" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Image Status"></ng-select>
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12 col-sm-6 col-md-3'>
                <label>Evaluation Status</label>
                <ng-select id="evaluations" formControlName="evaluations" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Evaluation Status"></ng-select>
            </div>

            <div *ngIf='filters.type === "course"' class='col-xs-12'>
                <label>Statewide Tags</label>
                <ng-select id="tagStatewide" formControlName="tagStatewide" [items]="tagsStatewide" bindValue="id" bindLabel="name" placeholder="Select Statewide Tags" [multiple]='true'></ng-select>
            </div>

            <div class='col-xs-6'>
                <label>Start Date</label>
                <div id="startDate" formControlName="startDate" class="input-group" a2e-datetimepicker [options]="filterDateOptions">
                    <input type="text" placeholder="Start Date" class="form-control"/>
                    <!-- for bootstrap 4 <span class="input-group-text"> -->
                        <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                        </span>
                    <!-- </span> -->
                </div>
            </div>

            <div class='col-xs-6'>
                <label>End Date</label>
                <div id="endDate" formControlName="endDate" class="input-group" a2e-datetimepicker [options]="filterDateOptions">
                    <input type="text" placeholder="End Date" class="form-control"/>
                    <!-- for bootstrap 4 <span class="input-group-text"> -->
                        <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                        </span>
                    <!-- </span> -->
                </div>
            </div>

            <!-- <div *ngIf='filters.type === "registration"' class='col-xs-12 col-sm-6 col-md-4'>
                <label>Registration Status</label>
                <ng-select [items]="status" [(ngModel)]="filters.status" bindValue="status_id" bindLabel="name" [multiple]="false" [closeOnSelect]="true" placeholder="Select Status" [clearSearchOnAdd]=true (change)="update()"></ng-select>
            </div>  -->
        </div>
        <div class='row form-group' *ngIf="isLoading">
            <app-loading [isLoading]="isLoading"></app-loading>
        </div>
    </div>
</form>